import { useCallback, useEffect, useRef, useState } from 'react';

import { getTenant } from '../api/tenants.api';

import type {
  TenantBilling,
} from '../data/tenants.mock';


export function useTenantWorkspace(id: string | undefined) {

  const [tenant, setTenant] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const mountedRef = useRef(true);


  const loadTenant = useCallback(() => {
    if (!id) {
      setLoading(false);
      return Promise.resolve();
    }

    setLoading(true);
    return getTenant(id)
      .then((data) => {
        if (mountedRef.current) setTenant(data);
      })
      .catch((error) => {
        console.error('[tenant workspace]', error);
        if (mountedRef.current) setTenant(null);
      })
      .finally(() => {
        if (mountedRef.current) setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    mountedRef.current = true;

    if (!id) {
      setLoading(false);
      return () => { mountedRef.current = false; };
    }

    loadTenant();

    return () => {
      mountedRef.current = false;
    };
  }, [id, loadTenant]);


  const billing: TenantBilling = {
    plan: '—',
    cycle: '—',
    amount: '—',
    nextBillingAt: '—',
    paymentStatus: 'pending',
  };


  return {
    tenant,
    users: [],
    services: [],
    billing,
    timeline: [],
    loading,
    refetch: loadTenant,
  };
}
